import { Box, Tab, Tabs } from "@mui/material";
import { type SxProps, type Theme } from "@mui/material/styles";
import { useState } from "react";
import { BulkTariffImport } from "./bulk/bulk-tariff-import";
import TariffWizard from "./tariff-wizard";

const styles = {
  tabs: { borderBottom: 1, borderColor: "divider" },
} satisfies Record<string, SxProps<Theme>>;

/**
 * Tariff section of the Crown hub: switches between the single-tariff wizard and
 * the bulk importer. Both target the logged-in company and share the same
 * underlying import mutation; the bulk view loops it over many CSVs.
 */
const TariffSection = () => {
  const [tab, setTab] = useState<"single" | "bulk">("single");
  return (
    <Box>
      <Tabs
        sx={styles.tabs}
        value={tab}
        onChange={(_event, value: "single" | "bulk") => {
          setTab(value);
        }}
      >
        <Tab label="Single" value="single" />
        <Tab label="Bulk" value="bulk" />
      </Tabs>
      {tab === "single" ? <TariffWizard /> : <BulkTariffImport />}
    </Box>
  );
};

export default TariffSection;
